module.exports = __webpack_public_path__ + "img/game_detail_cannon20_express.167c54ae.jpg";